module.exports = __webpack_public_path__ + "static/media/icon10.ed6917cd.png";